import { render, staticRenderFns } from "./NewItemConversion.vue?vue&type=template&id=160ae525&scoped=true&"
import script from "./NewItemConversion.vue?vue&type=script&lang=js&"
export * from "./NewItemConversion.vue?vue&type=script&lang=js&"
import style0 from "./NewItemConversion.vue?vue&type=style&index=0&id=160ae525&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ae525",
  null
  
)

export default component.exports